import i18n from 'utility/Translate/I18n';

const second2Ms = 1000;
const minute2Ms = second2Ms * 60;
const hour2Ms = minute2Ms * 60;
const day2Ms = hour2Ms * 24;

// date input format: "2020-12-24"
export const getDate = (
    date: string | Date,
    format: string,
    customOptions?: Intl.DateTimeFormatOptions,
    removeDot?: boolean
) => {
    const newDate = new Date(date);
    let options: Intl.DateTimeFormatOptions = {};
    // https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
    if (format === 'M') {
        options = { month: 'long' };
    }
    if (!!customOptions) {
        options = {
            ...options,
            ...customOptions,
        };

        if (removeDot && customOptions.weekday === 'short') {
            const formattedDate = new Intl.DateTimeFormat(
                i18n.t('TRANS-locale'),
                options
            ).format(newDate);

            return formattedDate.replace('.', '');
        }
    }

    return new Intl.DateTimeFormat(i18n.t('TRANS-locale'), options).format(
        newDate
    );
};

export const getDays = (
    firstDate: string | Date,
    secondDate: string | Date
): number => {
    const departureDate: number = new Date(firstDate).getTime(),
        returnDate: number = new Date(secondDate).getTime();

    return Math.round((returnDate - departureDate) / day2Ms);
};

export const getTimeAgoString = (date: string | Date): string => {
    const dateDiff = new Date().getTime() - new Date(date).getTime();
    let dividend;
    let translationKey;

    if (dateDiff / hour2Ms < 24) {
        //less than 24h ago
        dividend = hour2Ms;
        translationKey = 'TRANS-hours-ago[i]';
    } else if (dateDiff / day2Ms < 14) {
        //less than 14 days ago
        dividend = day2Ms;
        translationKey = 'TRANS-days-ago[i]';
    } else {
        return getDate(date, '', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        });
    }
    return i18n.t(translationKey, {
        postProcess: 'interval',
        count: Math.round(dateDiff / dividend) || 1,
    });
};

export const getMonthAndYear = (date: string | Date) =>
    getDate(date, '', {
        month: 'long',
        year: 'numeric',
    });
